import React, {Component} from 'react'
import styled, {css} from 'styled-components'
import {GatsbyImage} from "gatsby-plugin-image";
import {media} from "utils/Media"

import LazyLoad from 'react-lazyload';

const BgImageWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    z-index: 2;
    top: 56px;
    transition: transform 0.5s ease-in-out;
    transform: scale(1);
    
    @media ${media.sm} {
        top: 48px;
    }
    
    ${props => props.noTitleBar && css`
        top: 0 !important;
    `}
    
    ${props => props.step2 && css`
        opacity: 0;
    `}
    
    ${props => props.scaleUp && css`
      transform: scale(1.1);
    `}
    
    .image {
        width: 100vw;
        height: 100vh;
    }
`

class BgImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            play: false
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.play && this.props.play && this.props.progress !== 1) {
            this.setState({
                play: true
            })
        }

        if ((this.state.play && this.props.progress === 1) || (this.state.play && this.props.progress === 0)) {
            this.setState({
                play: false
            })
        }
    }

    render() {

        return (
          <BgImageWrapper
            noTitleBar={this.props.noTitleBar}
            scaleUp={this.state.play}
          >
            <LazyLoad height={"100%"} once>
              <GatsbyImage image={this.props.overrideDefaultImage ? this.props.data.bgStep2Sm.childImageSharp.gatsbyImageData : this.props.data.bgStep1Sm.childImageSharp.gatsbyImageData}
                alt=""
                title=""
                className="image d-block d-sm-none"
              />
            </LazyLoad>
            <LazyLoad height={"100%"} once>
              <GatsbyImage image={this.props.overrideDefaultImage ? this.props.data.bgStep2Md.childImageSharp.gatsbyImageData : this.props.data.bgStep1Md.childImageSharp.gatsbyImageData}
                alt=""
                title=""
                className="image d-none d-sm-block d-lg-none"
              />
            </LazyLoad>
            <LazyLoad height={"100%"} once>
              <GatsbyImage image={this.props.overrideDefaultImage ? this.props.data.bgStep2Lg.childImageSharp.gatsbyImageData : this.props.data.bgStep1Lg.childImageSharp.gatsbyImageData}
                alt=""
                title=""
                className="image d-none d-lg-block d-xl-none"
              />
                </LazyLoad>
                <LazyLoad height={"100%"} once>
              <GatsbyImage image={this.props.overrideDefaultImage ? this.props.data.bgStep2.childImageSharp.gatsbyImageData : this.props.data.bgStep1.childImageSharp.gatsbyImageData}
                alt=""
                title=""
                className="image d-none d-xl-block"
              />
            </LazyLoad>
          </BgImageWrapper>
        )
    }
}

export default BgImage